enum StatementConciliationActionType {
  CREATE = 'create',
  GENERATE_ADVANCE = 'generate-advance',
  SEARCH = 'search',
  WRITE_OFF = 'write-off',
  UNDO = 'undo',
  SHOW_ERP_ERRORS = 'show_erp_errors',
  WRITE_OFF_BATCH = 'write-off-batch',
}

export default StatementConciliationActionType;
